var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterWawe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 124,
    viewBox: "0 0 161 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.0809 123.088L78.8092 48.4144L69.0136 100.866L61.0315 58.1251L50.4674 95.8351L42.5583 64.2032L0 58.1545H47.715L50.8253 70.5944L62.3026 29.6285L69.0136 65.5643L81.2591 0L87.844 78.4044L99.0421 25.0637L105.033 67.8372L107.858 58.1545H161L112.823 64.2032L102.79 98.5926L97.7609 62.6899L85.0809 123.088Z",
    fill: "#E8604A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterWawe);
export default __webpack_public_path__ + "static/media/footerWawe.1c12b912a67cbcebb3ced3f19e4a17e8.svg";
export { ForwardRef as ReactComponent };